import { CheckCircle2 } from 'lucide-react';
import type { DispatchPreview } from '../dispatch.api';
import { EligibilityCheckRow } from '../public/EligibilityCheckRow';

interface DispatchEligibilityProps {
  preview: DispatchPreview;
  canApprove: boolean;
  onOverridden: () => void;
}

/** Why the engine refuses this crew now, check by check, each with the Override action for an approver. Nothing to show when it is eligible. */
export function DispatchEligibility({ preview, canApprove, onOverridden }: DispatchEligibilityProps) {
  const { blocks, isEligible } = preview.eligibility;
  const window = { windowStart: preview.timeline.start, windowEnd: preview.timeline.end };
  return (
    <section aria-label="Eligibility" className="rounded-lg border border-line bg-surface p-5">
      <h2 className="mb-3 text-base font-semibold text-fg">Eligibility</h2>
      {isEligible && (
        <p className="flex items-center gap-2 text-sm text-fg">
          <CheckCircle2 className="size-4 text-success" aria-hidden /> The crew passes every check today.
        </p>
      )}
      {blocks.map((block) => (
        <div key={`${block.resource}:${block.id ?? 'together'}`} className="mb-2">
          <h3 className="text-sm font-medium text-fg">{block.label}</h3>
          {block.checks.map((check) =>
            block.id && block.resource !== 'combination' ? (
              <EligibilityCheckRow
                key={`${check.check}:${check.code}`}
                check={check}
                tripId={preview.trip.id}
                resource={block.resource}
                resourceId={block.id}
                resourceLabel={block.label}
                window={window}
                canApprove={canApprove}
                onOverridden={onOverridden}
              />
            ) : (
              <p key={`${check.check}:${check.code}`} className="py-1 text-sm text-muted">
                {check.reason ?? check.code}
              </p>
            ),
          )}
        </div>
      ))}
    </section>
  );
}
